import { ActionIcon, CopyButton, Group, Text, Tooltip } from '@mantine/core'
import { TbCheck, TbCopy } from 'react-icons/tb'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

type CopyableIdProps = {
  value: string
  display?: ReactNode
  size?: 'xs' | 'sm' | 'md' | 'lg'
  monospace?: boolean
  c?: string
  truncate?: boolean
}

const CopyableId = ({ value, display, size = 'sm', monospace = true, c, truncate }: CopyableIdProps) => {
  const { t } = useTranslation('unexpectedEvents')

  return (
    <Group gap={4} wrap="nowrap" align="center">
      {display !== null && (
        <Text
          size={size}
          c={c}
          fw={500}
          ff={monospace ? 'monospace' : undefined}
          truncate={truncate ? 'end' : undefined}
          title={value}
        >
          {display ?? value}
        </Text>
      )}
      <CopyButton value={value} timeout={1500}>
        {({ copied, copy }) => (
          <Tooltip label={copied ? t('copy.copied') : t('copy.copy')} withArrow position="top">
            <ActionIcon
              variant="subtle"
              color={copied ? 'teal' : 'gray'}
              size="sm"
              onClick={event => {
                event.preventDefault()
                event.stopPropagation()
                copy()
              }}
              aria-label={copied ? t('copy.copied') : t('copy.copy')}
            >
              {copied ? <TbCheck size={14} /> : <TbCopy size={14} />}
            </ActionIcon>
          </Tooltip>
        )}
      </CopyButton>
    </Group>
  )
}

export default CopyableId
